<template>
  <!--<div id="app">
    <img src="./assets/logo.png">
    <router-view/>
  </div>-->
  <v-app light>
    <v-toolbar>
    <!--<v-toolbar-side-icon></v-toolbar-side-icon>-->
      <v-toolbar-title><h5 style="color: #1565C0;font-size:15px">WYNUM LOGISTICS</h5></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn flat v-on:click="dashboard()" style="font-size:13px"><b>Dashboard</b></v-btn>
        <v-menu offset-y>
          <v-btn
          slot="activator"
          color="default"
          flat
          style="font-size:13px"
          >
            <b>Booking</b>
          </v-btn>
          <v-list>
            <v-list-tile>
              <router-link v-bind:to="'Freightforwardingbookingform'" style="text-decoration: none;color: inherit"><v-list-tile-title>Freight Forwarding</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'Customclearancebookingform'" style="text-decoration: none;color: inherit"><v-list-tile-title>Custom Clearance</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'Truckingaddregions'" style="text-decoration: none;color: inherit"><v-list-tile-title>Inland Logistics</v-list-tile-title></router-link>
            </v-list-tile>
          </v-list>
        </v-menu>
        <!--<v-btn flat v-on:click="hubmanagement()" style="font-size:13px"><b>HUB Management</b></v-btn>-->
        <v-menu offset-y>
          <v-btn
          slot="activator"
          color="default"
          flat
          style="font-size:13px"
          >
            <b>Transportation</b>
          </v-btn>
          <v-list>
            <v-list-tile>
              <router-link v-bind:to="'Truckingaddregions'" style="text-decoration: none;color: inherit"><v-list-tile-title>Transporter Planning</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'Transportationinbounddelivery'" style="text-decoration: none;color: inherit"><v-list-tile-title>Delivery Management</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'Transportationtrip'" style="text-decoration: none;color: inherit"><v-list-tile-title>Trip Management</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'Transportationinbounddispatch'" style="text-decoration: none;color: inherit"><v-list-tile-title>Dispatch Management</v-list-tile-title></router-link>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-menu offset-y>
          <v-btn
          slot="activator"
          color="default"
          flat
          style="font-size:13px"
          >
            <b>Container Management</b>
          </v-btn>
          <v-list>
            <v-list-tile>
              <router-link v-bind:to="'Dailyfullloadreport'" style="text-decoration: none;color: inherit"><v-list-tile-title>Daily Full Load Report</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'Emptycontainerreport'" style="text-decoration: none;color: inherit"><v-list-tile-title>Empty Container Report</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'Onholdreport'" style="text-decoration: none;color: inherit"><v-list-tile-title>Containers on Hold</v-list-tile-title></router-link>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn flat v-on:click="warehousemanagement()" style="font-size:13px"><b>Warehouse Management</b></v-btn>
        <v-btn flat v-on:click="wynumtrack()" style="font-size:13px"><b>Wynum Track</b></v-btn>
        <v-menu offset-y>
          <v-btn
          slot="activator"
          color="default"
          flat
          style="font-size:13px"
          >
            <b>Settings</b>
          </v-btn>
          <v-list>
            <v-list-tile>
              <router-link v-bind:to="'settings'" style="text-decoration: none;color: inherit"><v-list-tile-title>Create User</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'addressbook'" style="text-decoration: none;color: inherit"><v-list-tile-title>Address Book</v-list-tile-title></router-link>
            </v-list-tile>
            <v-list-tile>
              <router-link v-bind:to="'mybookings'" style="text-decoration: none;color: inherit"><v-list-tile-title>My Booking</v-list-tile-title></router-link>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn flat style="color:#1565C0;font-size:13px"><b>Logout</b></v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <!--<v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
    >
      <v-list>
        <v-list-tile @click="right = !right">
          <v-list-tile-action>
            <v-icon light>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>-->
  </v-app>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      items: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],
      items1: [
        {title: 'Daily Full Load Report', link: '/dailyfullloadreport'},
        {title: 'Empty Container Report', link: ''},
        {title: 'Containers on Hold', link: ''}
      ]
    }
  },
  methods: {
    dashboard () {
      this.$router.push('/Dashboard')
    },
    wynumtrack () {
      this.$router.push('/Wynumtrack')
    },
    warehousemanagement () {
      this.$router.push('/Warehousemanagement')
    },
    activate (el) {
      this.active_el = el
    }
    /* hubmanagement () {
      this.$router.push('/Hubmanagement')
    } */
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.active_el {
  background-color: #00C853
}
</style>



// WEBPACK FOOTER //
// src/App.vue